module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_81.1b0e9a32.jpg";